import type filterZh from '../zh/filter';

const filter: typeof filterZh = {
  selected: 'Điều kiện đã chọn',
  clear: 'Xóa tất cả',
  remove: 'Xóa bộ lọc {{name}}'
};

export default filter;
